export default __webpack_public_path__ + "static/media/money3.b41efd16.jpg";